// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"233":"c1f3457e","645":"fc9b44c2"}[chunkId] + ".chunk.css";
};